module.exports = __webpack_public_path__ + "static/media/Profile2.0b6cbccd.jpeg";